import React from 'react';
import { useSelector } from 'react-redux';

import {
  Grid,
  TextField,
  IconButton,
} from '@mui/material';

import SendIcon from '@mui/icons-material/Send';

import { useSendMessageMutation } from 'app/features/chat/chatApi';

const Compose = () => {
  const [sendMessage] = useSendMessageMutation();
  const [content, setContent] = React.useState('');
  const textFieldRef = React.useRef(null);

  const currentContact = useSelector((state) => {
    return state.nfChat.currentContact;
  });

  const onSendClick = () => {
    textFieldRef.current.value = '';

    sendMessage({
      content,
      recipientId: currentContact.other_user.id,
      refId: Date.now(),
    });
  };

  return (
    <Grid
      container
      sx={{
        bottom: 0,
        height: '70px',
        width: '100%',
        backgroundColor: '#bbb',
      }}
    >
      <Grid item xs={12}>
        <TextField
          label="Type something here..."
          multiline
          rows={2}
          variant="outlined"
          fullWidth
          onChange={(event) => setContent(event.target.value)}
          inputRef={textFieldRef}
        />
      </Grid>
      <Grid item xs={12}>
        <IconButton onClick={onSendClick}>
          <SendIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default Compose;
